import { render, staticRenderFns } from "./AmenitiesCard.vue?vue&type=template&id=a31ba6e6&"
import script from "./AmenitiesCard.vue?vue&type=script&lang=js&"
export * from "./AmenitiesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports